import React from 'react';
import { Link } from 'react-router-dom';

function ClientItem(props) {
  return (
    <>
      <li className='client__item'>
        <Link className='client__item__link' to={props.path}>
          <figure className='client__item__pic-wrap' data-category={props.label}>
            <img
              className='client__item__img'
              alt='DKP'
              src={props.src}
            />
          </figure>
          <div className='client__item__info'>
            <h5 className='client__item__text'>{props.text}</h5>
          </div>
        </Link>
      </li>
    </>
  );
}

export default ClientItem;
